import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'baseline', 'Baseline', [["path",{"d":"M4 20h16"}],["path",{"d":"M8 16v-8a4 4 0 1 1 8 0v8"}],["path",{"d":"M8 10h8"}]]);